import { DueDiligenceService } from './../../services/due-diligence/due-diligence.service';
import { LicenseDataService } from './../../services/agentLicense/license-data.service';
import { InsuranceService } from '../../services/insurance/insurance.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';
import { ChangeLogService } from '../../services/change_log/change-log.service';
import * as momenttimezone from 'moment-timezone';
import { AgentDashboardService } from '../../services/agent_dashboard/agent-dashboard.service';
import { LocationdocumentsService } from '../../services/locationdocuments/locationdocuments.service';
import { AgentEmployeeService } from '../../services/agent-employee/agent-employee.service';
import { empty } from 'rxjs/observable/empty';

@Component({
  selector: 'app-pending-approval-dialog',
  templateUrl: './pending-approval-dialog.component.html',
  styleUrls: ['./pending-approval-dialog.component.css']
})
export class PendingApprovalDialogComponent implements OnInit {
  public submitFormData: any;
  vendorName;
  agentId: any;
  locationId: any;
  loginId = '';
  firstName;
  lastName;
  externalURL: any;
  public logFormData: any;
  previousValues: any = [];
  previousFileName: any;
  errMsg;
  errFlag: boolean = false;
  DocTypeErrMsg;
  DocTypeErr: boolean = false;
  matSpinner: boolean = false;
  errorMessage: String = '';
  errorEnable: boolean = false;
  MasterVendorId: any;
  data: any = {
    LicenseNumber: '',
    IssueDate: '',
    OwnerName: '',
    DateSigned: '',
    agentName: '',
    EINOrSSN: '',
    ExpirationDate: '',
    IssueState: '',
    uploadedFile: '',
    FileName: '',
  }

  DataLicense = {
    issuedate: Date,
    issuestate: '',
    licensenumber: '',
    expirationdate: '',
    fileName: '',
    docid: '',
    documentType: '',
    documentName: '',
    MasterVendorId: '',
    VendorLicenseId: '',
    uploadDate: new Date(),
    documentLink: '',
    delete: 0,
    DocumentStatus: ''
  }

  EmployeeData = {
    vendor_id: '',
    expiry_dtm: '',
    completion_dtm: new Date(),
    document_link: '',
    issue_dtm: new Date(),
    file_name: '',
    updated_by: this.loginId,
    DocumentStatus: '',
    docId: ''
  }

  insuranceData = {
    documentStatus: '',
    documenttype: '',
    documentcode: '',
    fileName: '',
    exempt_check: false,
    docid: '',
    MasterVendorId: '',
    VendorInsuranceId: '',
    policynum: '',
    phonenum: '',
    contact: '',
    insurancevendor: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    postalcode: '',
    expiration: Date,
    insuranceExpiration: Date,
    autoexpiration: Date,
    generalliabilityoccurance: '',
    generalliabilityaggregate: '',
    wrongfullliabilitylimit: '',
    workmascompliabilitylimit: '',
    onhookormotorliabilitylimit: '',
    autoliabilitylimit: '',
    garageliabilitylimit: '',
    cancellationnotice: false,
    storagelocation: false,
    parasinsured: false,
    documentlink: ''
  };
  insurancecarriers: any = [];

  constructor(
    private agentEmployeeService: AgentEmployeeService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private agentDashboardService: AgentDashboardService,
    public dialogRef: MatDialogRef<PendingApprovalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public licenseData: any,
    public licenseService: LicenseDataService,
    private changelogservice: ChangeLogService,
    private dueDiligenceService: DueDiligenceService,
    @Inject(MAT_DIALOG_DATA) public agentData: any,
    private locationService: LocationdocumentsService,
    private insuranceservice: InsuranceService,
    @Inject(MAT_DIALOG_DATA) public employeeData: any

  ) { }

  ngOnInit() {
    this.locationId = localStorage.getItem("LocationId");
    this.loginId = localStorage.getItem('loginID');
    this.MasterVendorId = localStorage.getItem("AgentId");
    this.vendorName = localStorage.getItem('AgentName');
    this.firstName = localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
    this.agentId = localStorage.getItem("AgentId");
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  validateDoc() {
    if (this.agentData.pagename == "due-diligence") {
      if (this.agentData.type === 'update') {
        this.data = this.agentData.data;
        if (this.data.ExpirationDate) {
          const setTime = new Date(this.data.ExpirationDate);
          setTime.setHours(19);
          setTime.setMinutes(59);
          setTime.setSeconds(59);
          const estTimeZone = "America/New_York";
          const format = "YYYY-MM-DDTHH:mm:ss.SSSZ";
          var updatedExpirationDate = momenttimezone(setTime).tz(estTimeZone).format(format);
          /*** The following logic for Daylight Savings ***/
          if (updatedExpirationDate.includes('-05:00')) {
            updatedExpirationDate = updatedExpirationDate.replace('19:59:59', '18:59:59');
          }
        }

        this.logFormData = {
          "document_type": this.agentData.data.DocumentTypeName,
          "document_category": this.agentData.data.DocumentCategory,
          "transaction_type": "update",
          "vendor_id": this.agentId
        }
        this.submitFormData = {
          "MasterVendorId": this.agentId,
          "DocumentTypeCode": this.agentData.data.DocumentTypeCode,
          "OwnerName": this.data.OwnerName,
          "DateSigned": this.data.DateSigned,
          "LicenseNumber": this.data.LicenseNumber,
          "IssueDate": this.data.IssueDate,
          "ExpirationDate": updatedExpirationDate,
          "EINOrSSN": this.data.EINOrSSN || null,
          "FileName": this.data.FileName,
          "DocumentLink": this.externalURL,
          "IssueState": this.data.IssueState,
          "DocumentStatus": "In Progress"
        }
        this.submitFormData.LastUpdatedBy = this.loginId;
        this.logFormData.modified_by = this.loginId;

        this.dueDiligenceService.updateDueDocuments(this.agentData.data._id, this.submitFormData).subscribe(res => {
          this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Update a" + ' ' + this.agentData.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
          this.dueDiligenceService.load.next('success');
          this.agentDashboardService.load.next('success');
          this.onNoClick();
          if (this.logFormData.transaction_type == "update") {
            this.logFormData.transaction_type = "Validation";
            this.previousValues = localStorage.getItem('old');
            this.logFormData.previous_fields = JSON.parse(this.previousValues);
            this.logFormData.collection_name = "vendor_due_diligence_documents";

            this.changelogservice.sendLogs(this.logFormData).subscribe(res => {
            }, err => {
              this.errMsg = err;
              this.errFlag = true;
              this.matSpinner = false;
            });
          }
        }, error => {
          this.DocTypeErrMsg = 'Due Diligence Service' + ' ' + error;
          this.DocTypeErr = true;
          this.matSpinner = false;
        });
      }
    } else if (this.agentData.pagename == "license") {
      if (this.licenseData.type === 'update') {
        this.logFormData = {
          "document_type": this.licenseData.data.DocumentTypeName,
          "document_category": this.licenseData.data.DocumentCategory,
          "transaction_type": "update",
          "vendor_id": this.MasterVendorId,
          "modified_by": this.loginId
        }
        if (this.licenseData.data.ExpirationDate !== null && this.licenseData.data.ExpirationDate !== '') {
          const setTime = new Date(this.licenseData.data.ExpirationDate);
          setTime.setHours(19);
          setTime.setMinutes(59);
          setTime.setSeconds(59);
          const estTimeZone = "America/New_York";
          const format = "YYYY-MM-DDTHH:mm:ss.SSSZ";
          var updatedExpirationDate = momenttimezone(setTime).tz(estTimeZone).format(format);
          /*** The following logic for Daylight Savings ***/
          if (updatedExpirationDate.includes('-05:00')) {
            updatedExpirationDate = updatedExpirationDate.replace('19:59:59', '18:59:59');
          }
        }
        this.DataLicense.MasterVendorId = this.licenseData.data.MasterVendorId;
        this.DataLicense.VendorLicenseId = this.licenseData.data.VendorLicenseId;
        this.DataLicense.documentName = this.licenseData.data.DocumentTypeName;
        this.DataLicense.docid = this.licenseData.data._id;
        this.DataLicense.documentType = this.licenseData.data.DocumentTypeCode;
        this.DataLicense.fileName = this.licenseData.data.FileName;
        this.DataLicense.expirationdate = updatedExpirationDate;
        this.DataLicense.issuedate = this.licenseData.data.IssueDate;
        this.DataLicense.issuestate = this.licenseData.data.IssueState;
        this.DataLicense.licensenumber = this.licenseData.data.LicenseNumber;
        this.DataLicense.documentLink = this.licenseData.data.DocumentLink;
        this.licenseService.validateDocument(this.DataLicense).subscribe(res => {
          this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Update a" + ' ' + this.licenseData.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
          this.licenseService.load.next('success');
          this.dialogRef.close();
          if (this.logFormData.transaction_type == "update") {
            this.logFormData.transaction_type = "Validation";
            this.logFormData.document_category = this.licenseData.category;
            this.logFormData.vendor_id = this.licenseData.data.MasterVendorId;
            this.previousValues = localStorage.getItem('old');
            this.logFormData.previous_fields = JSON.parse(this.previousValues);
            this.logFormData.collection_name = "vendor_license_documents";
            this.changelogservice.sendLogs(this.logFormData).subscribe(res => {
            }, err => {
              this.errMsg = err;
              this.errFlag = true;
              this.matSpinner = false;
            });
          }
        }, error => {
          this.licenseService.load.next('fail');
          this.errMsg = "update license document: " + error;
          this.errFlag = true;
          this.matSpinner = false;
        });
      }
    } else if (this.agentData.pagename == 'insurance') {
      this.logFormData = {
        "document_type": this.agentData.data.DocumentType,
        "document_category": this.agentData.data.DocumentCategory,
        "transaction_type": "update",
        "vendor_id": this.agentId,
        "modified_by": this.loginId
      }
      this.insuranceservice.insdetails(this.agentData.data._id).subscribe(res => {
        localStorage.setItem('old', JSON.stringify(res.Documents[0]));
        this.insuranceData.documentStatus = 'In Progress';
        this.insuranceData.docid = res.Documents[0]._id;
        this.insuranceData.MasterVendorId = res.Documents[0].MasterVendorId;
        this.insuranceData.VendorInsuranceId = res.Documents[0].VendorInsuranceId;
        this.insuranceData.documenttype = res.Documents[0].DocumentType;
        this.insuranceData.documentcode = res.Documents[0].DocumentTypeCode;
        this.insuranceData.fileName = res.Documents[0].FileName;
        this.insuranceData.exempt_check = res.Documents[0].WorksmanExemptCheck ? true : false;
        this.insuranceData.expiration = res.Documents[0].ExpirationDate; 
        this.insuranceData.insuranceExpiration = res.Documents[0].InsuranceExpiration; 
        this.insuranceData.documentlink = res.Documents[0].DocumentLink;
        this.insurancecarriers = res.Documents[0].InsuranceCarrier;
        this.insuranceData.insurancevendor = res.Documents[0].InsuranceVendor;
        this.insuranceData.city = res.Documents[0].City;
        this.insuranceData.policynum = res.Documents[0].PolicyNumber;
        this.insuranceData.phonenum = res.Documents[0].PhoneNumber;
        this.insuranceData.contact = res.Documents[0].Contact;
        this.insuranceData.address1 = res.Documents[0].Address1;
        this.insuranceData.address2 = res.Documents[0].Address2;
        this.insuranceData.state = res.Documents[0].State;
        this.insuranceData.postalcode = res.Documents[0].PostalCode;
        this.insuranceData.autoexpiration = res.Documents[0].AutoLiabilityExpirationDate;
        this.insuranceData.generalliabilityoccurance = res.Documents[0].GeneralLiabilityOccurance;
        this.insuranceData.generalliabilityaggregate = res.Documents[0].GeneralLiabilityAggregate;
        this.insuranceData.wrongfullliabilitylimit = res.Documents[0].WrongfulLiabilityLimit;
        this.insuranceData.workmascompliabilitylimit = res.Documents[0].WorkmansCompLiabilityLimit;
        this.insuranceData.onhookormotorliabilitylimit = res.Documents[0].OnhookormotorLiabilityLimit;
        this.insuranceData.autoliabilitylimit = res.Documents[0].AutoLiabilityLimit;
        this.insuranceData.garageliabilitylimit = res.Documents[0].GarageLiabilityLimit;
        if (res.Documents[0].InsuranceCarrier === null || res.Documents[0].InsuranceCarrier === undefined || res.Documents[0].InsuranceCarrier === empty) {
          this.insurancecarriers = [];
        }
        if (res.Documents[0].CancellationNotice === 'Y') {
          this.insuranceData.cancellationnotice = true;
        } else {
          this.insuranceData.cancellationnotice = false;
        }
        if (res.Documents[0].StorageLocation === 'Y') {
          this.insuranceData.storagelocation = true;
        } else {
          this.insuranceData.storagelocation = false;
        }
        if (res.Documents[0].ParAsInsured === 'Y') {
          this.insuranceData.parasinsured = true;
        } else {
          this.insuranceData.parasinsured = false;
        }

        this.insuranceservice.updateAgentInsurance(this.insuranceData, this.insurancecarriers).subscribe(res => {
          this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Update a" + ' ' + this.agentData.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
          this.insuranceservice.load.next('success');
          this.dialogRef.close();
          if (this.logFormData.transaction_type == "update") {
            this.logFormData.transaction_type = "Validation";
            this.logFormData.document_category = this.agentData.data.DocumentCategory;
            this.logFormData.vendor_id = this.agentData.data.MasterVendorId;
            this.previousValues = localStorage.getItem('old');
            this.previousFileName = localStorage.getItem('oldVendorInsuranceFileName');
            this.logFormData.previous_fields = JSON.parse(this.previousValues);
            this.logFormData.collection_name = "vendor_insurance_details";
            this.logFormData.previous_fields.FileName = JSON.parse(this.previousFileName);
            this.changelogservice.sendLogs(this.logFormData).subscribe(res => { }, err => {
              this.errMsg = err;
              this.errFlag = true;
              this.matSpinner = false;
            });
          }
        }, error => {
          this.errMsg = "Update Vendor insurance" + error;
          this.errFlag = true;
          this.matSpinner = false;
          this.insuranceservice.load.next('fail');
        });
      }, error => {
        this.errFlag = true;
        this.errMsg = "Insurance details: " + error;
      });
    } else if (this.agentData.pagename == "employee-doc") {
        if (this.employeeData.type === 'update') {
          let dt = new Date(this.employeeData.data.CompletionDate);
          if (dt !== undefined)
            this.employeeData.data.CompletionDate = dt;
          let dt1 = new Date(this.employeeData.data.IssueDate);
          if (dt1 !== undefined)
            this.employeeData.data.IssueDate = dt1;
          this.logFormData = {
            "document_type": this.employeeData.data.DocumentTypeName,
            "document_category": this.employeeData.data.DocumentCategory,
            "transaction_type": "update",
            "vendor_id": this.agentId
          }
          if (this.employeeData.data.ExpirationDate !== null && this.employeeData.data.ExpirationDate !== '') {
            const setTime = new Date(this.employeeData.data.ExpirationDate);
            setTime.setHours(19);
            setTime.setMinutes(59);
            setTime.setSeconds(59);
            const estTimeZone = "America/New_York";
            const format = "YYYY-MM-DDTHH:mm:ss.SSSZ";
            var updatedExpirationDate = momenttimezone(setTime).tz(estTimeZone).format(format);
            /*** The following logic for Daylight Savings ***/
            if (updatedExpirationDate.includes('-05:00')) {
              updatedExpirationDate = updatedExpirationDate.replace('19:59:59', '18:59:59');
            }
          }
          this.EmployeeData.vendor_id = this.employeeData.data.MasterVendorId;
          this.EmployeeData.expiry_dtm = updatedExpirationDate;
          this.EmployeeData.completion_dtm = dt;
          this.EmployeeData.document_link = this.employeeData.data.DocumentLink;
          this.EmployeeData.issue_dtm = dt1;
          this.EmployeeData.file_name = this.employeeData.data.FileName;
          this.EmployeeData.updated_by = this.employeeData.data.LastUpdatedBy;
          this.EmployeeData.docId = this.employeeData.data._id;
          this.logFormData.modified_by = this.loginId;
          this.agentEmployeeService.validateEmpDocuments(this.EmployeeData).subscribe(res => {
            this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Update a" + ' ' + this.agentData.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
            this.agentEmployeeService.load.next('success');
            this.onNoClick();
            if (this.logFormData.transaction_type == "update") {
              this.logFormData.document_category = this.employeeData.category;
              this.logFormData.transaction_type = "Validation";
              this.logFormData.vendor_id = this.employeeData.data.MasterVendorId;
              this.previousValues = localStorage.getItem('old');
              this.logFormData.previous_fields = JSON.parse(this.previousValues);
              this.logFormData.collection_name = "vendor_employee_documents";
              this.changelogservice.sendLogs(this.logFormData).subscribe(res => {
              }, err => {
                this.errMsg = err;
                this.errFlag = true;
                this.matSpinner = false;
              });
            }
          }, error => {
            this.errMsg = 'Employee Documents Service' + ' ' + error;
            this.errFlag = true;
            this.matSpinner = false;
          });
        }
    } else if (this.agentData.pagename == "location") {
        if (this.agentData.type === 'update') {
          this.data = this.agentData.data;
          if (this.data.ExpirationDate !== null && this.data.ExpirationDate !== '') {
            const setTime = new Date(this.data.ExpirationDate);
            setTime.setHours(19);
            setTime.setMinutes(59);
            setTime.setSeconds(59);
            const estTimeZone = "America/New_York";
            const format = "YYYY-MM-DDTHH:mm:ss.SSSZ";
            var testTimeZone = momenttimezone(setTime).tz(estTimeZone).format(format);
            /*** The following logic for Daylight Savings ***/
            if (testTimeZone.includes('-05:00')) {
              testTimeZone = testTimeZone.replace('19:59:59', '18:59:59');
            }
          }
          
          this.logFormData = {
            "document_type": this.agentData.data.DocumentTypeName,
            "document_category": this.agentData.data.DocumentCategory,
            "transaction_type": "update",
            "vendor_id": this.agentId
          }

          this.submitFormData = {
            "vendor_id": this.agentData.data.MasterVendorId,
            "location_id": this.agentData.data.LocationId,
            "docId": this.agentData.data._id,
            "document_type": this.agentData.data.DocumentTypeCode,
            "document_name": this.agentData.data.DocumentTypeName,
            "location_type": this.agentData.data.LocationType,
            "location_name": this.agentData.data.LocationName,
            "document_link": this.agentData.data.DocumentLink,
            "filename": this.agentData.data.FileName,
            'inspection_date': new Date(this.agentData.data.InspectionDate),
            'inspection_done_by': this.agentData.data.InspectionDoneBy,
            'expiration_date': testTimeZone,
            'pic_description': this.agentData.data.PictureDescription,
            "DocumentStatus":  "In Progress",
            "updated_by": this.loginId
          }

          this.logFormData.modified_by = this.loginId;

          this.locationService.updateDueDocuments(this.submitFormData).subscribe(res => {
            this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Update a" + ' ' + this.agentData.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
            this.locationService.load.next('success');
            this.agentDashboardService.load.next('success');
            this.onNoClick();
            if (this.logFormData.transaction_type == "update") {
              this.logFormData.transaction_type = "Validation";
              this.previousValues = localStorage.getItem('old');
              this.logFormData.previous_fields = JSON.parse(this.previousValues);
              this.logFormData.collection_name = "vendor_location_documents";

              this.changelogservice.sendLogs(this.logFormData).subscribe(res => { }, err => {
                this.errMsg = err;
                this.errFlag = true;
                this.matSpinner = false;
              });
            }
          }, error => {
            this.DocTypeErrMsg = 'Location Documents Service' + ' ' + error;
            this.DocTypeErr = true;
            this.matSpinner = false;
          });
        }
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/pending-approval-dialog/pending-approval-dialog.component.ts